import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';

export interface IReorderSurveyTemplateFieldsParams {
	templateId: string;
	fieldIds: string[];
}

export interface IReorderSurveyTemplateFieldsOptions {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.CustomForm) => void;
}

/**
 * Admin: Reorder custom form fields in a survey template.
 * Updates the display order of questions/fields in the template.
 *
 * @param options - Mutation options including success/error callbacks
 * @returns React Query mutation result
 */
export const useReorderSurveyTemplateFieldsMutation = (options: IReorderSurveyTemplateFieldsOptions = {}) => {
	const { onError, onSuccess } = options;
	const userSession = useAdminUserSession();

	return useMutation({
		mutationFn: (params: IReorderSurveyTemplateFieldsParams) => {
			const { templateId, fieldIds } = params;

			return userSession.webServiceHelper.callAsync<Api.CustomForm>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `admin/surveytemplate/${templateId}/customForm/fields/reorder`,
				}),
				'PUT',
				{ fieldIds }
			);
		},
		onSuccess,
		onError,
	});
};
